export const GET_ALL_VISIT_GROUP_REQUEST = 'GET_ALL_VISIT_GROUP_REQUEST';
export const GET_ALL_VISIT_GROUP_SUCCESS = 'GET_ALL_VISIT_GROUP_SUCCESS';
export const GET_ALL_VISIT_GROUP_FAILURE = 'GET_ALL_VISIT_GROUP_FAILURE';

export const GET_VISIT_GROUP_BY_ID_REQUEST = 'GET_VISIT_GROUP_BY_ID_REQUEST';
export const GET_VISIT_GROUP_BY_ID_SUCCESS = 'GET_VISIT_GROUP_BY_ID_SUCCESS';
export const GET_VISIT_GROUP_BY_ID_FAILURE = 'GET_VISIT_GROUP_BY_ID_FAILURE';

export const ADD_VISIT_GROUP_REQUEST = 'ADD_VISIT_GROUP_REQUEST';
export const ADD_VISIT_GROUP_SUCCESS = 'ADD_VISIT_GROUP_SUCCESS';
export const ADD_VISIT_GROUP_FAILURE = 'ADD_VISIT_GROUP_FAILURE';

export const UPDATE_VISIT_GROUP_REQUEST = 'UPDATE_VISIT_GROUP_REQUEST';
export const UPDATE_VISIT_GROUP_SUCCESS = 'UPDATE_VISIT_GROUP_SUCCESS';
export const UPDATE_VISIT_GROUP_FAILURE = 'UPDATE_VISIT_GROUP_FAILURE';

export const UPDATE_VISIT_GROUP_STATUS_REQUEST = 'UPDATE_VISIT_GROUP_STATUS_REQUEST';
export const UPDATE_VISIT_GROUP_STATUS_SUCCESS = 'UPDATE_VISIT_GROUP_STATUS_SUCCESS';
export const UPDATE_VISIT_GROUP_STATUS_FAILURE = 'UPDATE_VISIT_GROUP_STATUS_FAILURE';
